import { isCountedUnit, unitLabel, type Translate } from '@d-orca/shared/client/logistics';

/** A waste figure as every waste surface prints it: a counted unit (bags,
 *  sheets…) keeps at most one decimal — "160.27 bags" claims a precision
 *  nobody counts in — a measured one (t, m3, kg…) its own precision. */
export function wasteNumber(value: number, unit: string): number {
  return isCountedUnit(unit) ? Math.round(value * 10) / 10 : value;
}

/** "4.1 t" — the figure, one space, and the unit in the viewer's language. */
export function wasteAmount(t: Translate, value: number, unit: string): string {
  return `${wasteNumber(value, unit)} ${unitLabel(t, unit)}`;
}
